import React from "react";
import { Modal, Fade, Box, Typography, Grid, Button } from "@mui/material";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import AnalyticsChart from "./AnalyticsChart";
import LineChart from "./LineChart";

const AnalyticsModal = ({ open, onClose, data, type }) => {
  return (
    <Modal
      open={open}
      onClose={() => {
        onClose(false);
      }}
      closeAfterTransition
    >
      <Fade in={open}>
        <Box
          sx={{
            backgroundColor: "grey", // grey background
            padding: 0,
            borderRadius: 3,
            maxWidth: "90vw", // Ensure it fits the screen width
            height: "90vh", // Allow the modal to take up most of the screen height
            overflow: "hidden",
            margin: "auto",
            marginTop: "5%",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            boxShadow: 5,
            border: "1px solid #ddd",
            position: "relative", // for positioning the footer absolutely
          }}
        >
          <Box
            sx={{
              p: 2,
              width: "90vw",
              paddingLeft: "60px",
              borderBottom: "1px solid #ddd",
              bgcolor: "#f5f5f5",
              display: "flex",
              alignItems: "center",
              marginBottom: "20px",
              position: "sticky", // Fixed header
              top: 0, // Stick to the top
              zIndex: 10, // Make sure it stays above other content
            }}
          >
            <Typography variant="h5" sx={{ fontWeight: 600, color: "#333" }}>
              Breakdown
            </Typography>
          </Box>

          {/* Content area with A4 aspect ratio */}
          <Box
            sx={{
              backgroundColor: "white", // white sheet inside modal
              padding: 3,
              display: "flex",
              justifyContent: "center", // Center horizontally
              alignItems: "center", // Center vertically

              width: "calc(100% - 100px)", // Limit width to 90% of the viewport width
              height: "calc(100% - 100px)", // Limit height to 90% of the viewport height
              aspectRatio: "1 / 1.414", // Maintain A4 aspect ratio (210mm x 297mm)
              margin: "10 auto", // Ensure it is centered in the modal
              fontSize: "16px", // Default font size
              lineHeight: 1.5, // Default line height
              overflowY: "scroll", // Allow scrolling if content exceeds

              "@media (max-width: 600px)": {
                fontSize: "14px", // Smaller font on small screens
              },
              "@media (max-width: 400px)": {
                fontSize: "12px", // Further smaller font on very small screens
              },
            }}
          >
            <Grid sx={{ marginTop: "400px" }}>
              <Grid
                container
                spacing={2}
                sx={{
                  background: "white",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={"/images/nucleusx.png"}
                  alt="Logo"
                  style={{ height: "200px", marginRight: "10px" }}
                />
              </Grid>
              <Grid container spacing={2} sx={{ background: "white" }}>
                <Grid item xs={12}>
                  <Typography
                    variant="h5"
                    align="center"
                    sx={{ fontWeight: "bold", color: "#333", marginBottom: 1 }}
                  >
                    Report Status Summary (in %)
                  </Typography>
                </Grid>

                {/* Analytics Chart */}
                <Grid item xs={12}>
                  <AnalyticsChart data={data} type={"Health"} />
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ background: "white" }}>
                <LineChart />
              </Grid>
            </Grid>
          </Box>
          <Box
            sx={{
              position: "absolute", // fix position at the bottom
              bottom: 0,
              left: 0,
              right: 0,
              display: "flex",
              justifyContent: "space-between",
              padding: 2,
              borderTop: "1px solid #ddd",
              bgcolor: "#f5f5f5",
            }}
          >
            <Button
              variant="outlined"
              onClick={() => {
                onClose(false);
              }}
            >
              <ChevronLeft />
            </Button>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

export default AnalyticsModal;
